import { LitElement, css, html, when } from 'lit'

/*
*   Выпадающее правое меню.
*   Иконки для кнопок в слотах back-icon close-icon.
*   При закрытии панель генерирует событие close.
*   Объект со структурой меню передаётся в menuItems.
*/

export class DzSideMenu extends LitElement {
    static get properties() {
        return {
            menuItems: { type: Object, state: true },
            linkPrefix: { type: String }
        }
    }

    updated(changes) {
        if (changes.has("menuItems")) {
            this.bottomPage = this.menuItems
        }
        super.update(changes)
    }

    constructor() {
        super()
        this.headers = ["Каталог"]
        this.history = []
        this.topPage = null
        this.bottomPage = null
        window.addEventListener("content.menuReady", (evt) => {
            this.menuItems = JSON.parse(window.localStorage.getItem(evt.detail))
        })
    }

    renderPageContent(page) {
        if (page) {
            return Object.keys(page).map((key) => {
                if (typeof(page[key]) === 'object') {
                    return html`<li class='item' @click=${() => this.slideNext(key)} part="item">${key}</li>`
                } else {
                    return html`<li class='item last' part="item"><a part="link" href='${page[key]}'>${key}</a></li>`
                }
            })
        }
    }

    render() {
        let output = []
        output.push(html`
            <header part="header">${this.headers[this.headers.length - 1]}</header>
        `)
        output.push(html`
            <button @click=${this.history.length ? this.slideBack : this.closePanel} part="button">
            ${
                when(this.history.length,
                    () => html`<slot name="back-icon"/>`,
                    () => html`<slot name="close-icon"/>`
                )
            }        
            </button>
        `)
        if (!this.bottomPage) {
            output.push(html`<slot name="load-message"/>`)
            return html`${output}`
        }
        output.push(html`
            <ul id="top-page" class="page" part="list">
               ${this.renderPageContent(this.topPage) }
            </ul>
        `)
        output.push(html`
            <ul id="bottom-page" class="page" part="list">
               ${this.renderPageContent(this.bottomPage)}
            </ul>
        `)
        return html`${output}`
    }

    closePanel() {
        let evt = new Event("close", {bubbles: true, composed: true})
        this.dispatchEvent(evt)
    }

    slideNext(selectedItem) {
        let top_element = this.renderRoot.getElementById("top-page")
        this.headers.push(selectedItem)
        this.history.push(this.bottomPage)
        this.topPage = this.bottomPage[selectedItem]
            
        top_element.onanimationend = () => {
            top_element.style.animation = null
            top_element.onanimationend = null
            this.bottomPage = this.topPage
            this.topPage = null
            this.requestUpdate()
        }    
        top_element.style.animation = `0.5s slidein`
        this.requestUpdate()
    }

    slideBack() {
        let top_element = this.renderRoot.getElementById("top-page")
        this.topPage = this.bottomPage
        this.headers.pop()
        this.bottomPage = this.history.pop()
        top_element.onanimationend = () => {
            top_element.style.animation = null
            top_element.onanimationend = null
            this.topPage = null
            this.requestUpdate()
        }
        top_element.style.animation = `0.5s slideout`
        this.requestUpdate()
    }

    static get styles() {
        return css`
            :host {
                display: inline-block;
                box-sizing: border-box;
                overflow: hidden;
                overflow-y: auto;
                position: relative;
                transition: 0.5s;
            }
            
            ul {
                all: initial;
            }
            
            header {
                position: relative;
                z-index: 3;
            }

            .page {
                position: absolute;
                top: 0;
                bottom: 0;
                left: 0;
                padding-top: 50px;
                overflow-y: auto;
                background: white;
                width: 100%;
                z-index: 1;
            }

            #top-page {
                left: 100%;
                z-index: 2;
            }

            .item {
                cursor: pointer;
            }

            button {
                appearance: none;
                background: none;
                border: none;
                position: absolute;
                top: 0;
                left: 0;
                z-index: 4;
                cursor: pointer;
            }

            @keyframes slidein {
                from {
                    left: 100%;
                }
                to {
                    left: 0;
                }
            }

            @keyframes slideout {
                from {
                    left: 0;
                }
                to {
                    left: 100%;
                }
            }
        `
    }
}

window.customElements.define('dz-side-menu', DzSideMenu)